export const isReturningCustomerDataKeys: { [key: string]: string } = {
  firstName: 'string',
  lastName: 'string',
  phone: 'string',
  email: 'string',
  zipcode: 'string',
  conceptId: 'number',
  weblocationId: 'number',
};
